module.exports = __webpack_public_path__ + "static/media/mainframe.4f3a8d94.jpg";